import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const ScheduleContribution = ({ size = 34, style }: IconProps) => {
  const { theme } = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M21.2513 28.3332C18.0874 28.3332 15.4076 27.2353 13.2117 25.0394C11.0159 22.8436 9.91797 20.1637 9.91797 16.9998C9.91797 13.8359 11.0159 11.1561 13.2117 8.96025C15.4076 6.76442 18.0874 5.6665 21.2513 5.6665C24.4152 5.6665 27.0951 6.76442 29.2909 8.96025C31.4867 11.1561 32.5846 13.8359 32.5846 16.9998C32.5846 20.1637 31.4867 22.8436 29.2909 25.0394C27.0951 27.2353 24.4152 28.3332 21.2513 28.3332ZM10.4138 27.9082C7.74575 27.5776 5.57943 26.3557 3.91484 24.2425C2.25026 22.1294 1.41797 19.7151 1.41797 16.9998C1.41797 14.2846 2.25026 11.8703 3.91484 9.75713C5.57943 7.64393 7.74575 6.42206 10.4138 6.0915V8.14567C8.33602 8.52345 6.67144 9.55643 5.42005 11.2446C4.16866 12.9328 3.54297 14.8512 3.54297 16.9998C3.54297 19.1484 4.16866 21.0669 5.42005 22.755C6.67144 24.4432 8.33602 25.4762 10.4138 25.854V27.9082ZM21.2513 26.2082C23.7777 26.2082 25.944 25.305 27.7503 23.4988C29.5565 21.6925 30.4596 19.5262 30.4596 16.9998C30.4596 14.4734 29.5565 12.3071 27.7503 10.5009C25.944 8.69463 23.7777 7.7915 21.2513 7.7915C18.7249 7.7915 16.5586 8.69463 14.7523 10.5009C12.9461 12.3071 12.043 14.4734 12.043 16.9998C12.043 19.5262 12.9461 21.6925 14.7523 23.4988C16.5586 25.305 18.7249 26.2082 21.2513 26.2082Z"
        fill={theme.icon.default}
      />
      <path
        d="M25.4144 22.4687L26.6894 21.1937L22.1844 16.6603V10.9653H20.4844V17.3403L25.4144 22.4687Z"
        fill={theme.icon.default}
      />
    </svg>
  );
};
